$( () => {
  const slider = $( '.bs-section--customers-what-our-customer-slider .slick-slider' );

  slider.on( 'click', '.slick-slide', ( event ) => {
    if ( event.target.tagName.toLowerCase() === 'a' ) {
      
      const clickedSlideIndex = $( event.currentTarget ).data( 'slickIndex' );
      slider.slick( 'slickGoTo', clickedSlideIndex ); 
    }
  } );

} );